export const calculateDistance = (highSchool, college) => {
  if (
    !highSchool ||
    !college ||
    highSchool.latitude === null ||
    highSchool.longitude === null ||
    Number.isNaN(Number(highSchool.latitude)) ||
    Number.isNaN(Number(highSchool.longitude)) ||
    (highSchool.latitude === 0 && highSchool.longitude === 0)
  ) {
    return false;
  } else {
    if (highSchool.longitude > 0) {
      highSchool.longitude = -highSchool.longitude;
    }
  }

  if (
    highSchool.latitude < -14.4 || // south of Samoa
    highSchool.latitude > 71.6 || // north of Alaska
    highSchool.longitude < -171 || // west of Alaska
    highSchool.longitude > -64 // east of USVI
  )
    return false;

  const toRad = (value) => (value * Math.PI) / 180;
  const R = 6371; // km
  const dLat = toRad(highSchool.latitude - college.latitude);
  const dLon = toRad(highSchool.longitude - college.longitude);
  const lat1 = toRad(college.latitude);
  const lat2 = toRad(highSchool.latitude);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  const miles = (d * 0.62).toFixed(0);

  if (isNaN(miles)) return false;

  return `${miles}`;
};
